export default __webpack_public_path__ + "static/media/manwithspeaker.181fc5ca.svg";